module.exports = __webpack_public_path__ + "img/clock.35b2292d.svg";